import React from 'react'

import { SERVICE_ACTION_TYPE, RECURRING_COLLECTION_ID, RECURRING_COLLECTION } from 'settings/constants/service'
import { isRecurringService } from 'utils/service'
import { normalizeCasing } from 'utils/string'

import ServiceActionTypeChip from './ServiceActionTypeChip'

const { COLLECTION } = SERVICE_ACTION_TYPE

export const getActionTypeAndLabel = (eventActionType?: string | null, serviceActionType?: string | null, serviceType?: string | null) => {
  const action = eventActionType || serviceActionType

  if (action) {
    return { action, label: normalizeCasing(action), id: action }
  }

  if (!action && isRecurringService(serviceType)) {
    return { action: COLLECTION, label: RECURRING_COLLECTION, id: RECURRING_COLLECTION_ID }
  }

  return { action: '', label: '', id: '' }
}

type Props = Omit<React.ComponentProps<typeof ServiceActionTypeChip>, 'action' | 'label'> & {
  serviceActionType?: string | null
  eventActionType?: string | null
  serviceType?: string | null
}

const ServiceActionTypeHelper: React.FC<Props> = ({ serviceActionType, eventActionType, serviceType, ...rest }) => {
  const { action, label } = getActionTypeAndLabel(eventActionType, serviceActionType, serviceType)

  return <ServiceActionTypeChip size="small" action={action} label={label} {...rest} />
}

export default ServiceActionTypeHelper
